import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('document-history-change-history-branch');
